document.addEventListener('DOMContentLoaded', () => {
  const policyBody = document.querySelector('.shopify-policy__body');
  if (!policyBody) return;

  const walker = document.createTreeWalker(policyBody, NodeFilter.SHOW_TEXT);
  let node = walker.nextNode();

  while (node) {
    node.nodeValue = node.nodeValue
      .replaceAll('RC25987', '820348')
      .replaceAll('info@attiaclothing.com', 'attia.inds@gmail.com')
      .replaceAll('INFO@ATTIACLOTHING.COM', 'attia.inds@gmail.com')
      .replaceAll('haisal@hotmail.com', 'attia.inds@gmail.com');
    node = walker.nextNode();
  }

  policyBody.querySelectorAll('a').forEach((link) => {
    const visibleEmail = link.textContent.trim().toLowerCase();
    const emailLink = link.getAttribute('href') || '';

    if (visibleEmail.includes('@') || emailLink.toLowerCase().includes('attiaclothing.com') || emailLink.toLowerCase().includes('hotmail.com')) {
      link.textContent = 'attia.inds@gmail.com';
      link.setAttribute('href', 'mailto:attia.inds@gmail.com');
    }
  });
});
